import styled from 'styled-components';
import Colors from 'library/constants/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px 40px 20px;
  background-color: ${Colors.shade07};
  background: ${Colors.shade08};
  box-shadow: 0 2px 10px rgba(45, 49, 50, 0.08);
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 145px;

  p, h1, h3, h2, span {
    line-height: 25px;
  }

  h1 {
    font-size: 24px;
  }

  h3 {
    font-size: 16px;
    margin: 24px 0 16px 0;
  }
  
  ul {
    margin: 0 auto;
  }
`;
